import { FlowObjectType, FlowObjectDefinition, FormSchema } from '../../../../models/flow-object.model';
import { ComissoesFilter, GruposFilter, OrganizacoesFilter, PapeisFilter, PatriarcasFilter, UnidadesFilter } from '../default/fod-default.pipe';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, signal, NO_ERRORS_SCHEMA } from '@angular/core';
import { ConfigSchema, ConfigSchemaSectionDocumentClass, ConfigSchemaSectionEDocsLocation, Stakeholder, StakeholderType, StakeholderTypeDescription } from '../../../../models/config-schema.model';
import { AcessoCidadaoService } from '../../../../services/acesso-cidadao.service';
import { OrganogramaService } from '../../../../services/organograma.service';
import { Organizacao, Unidade } from '../../../../models/organograma.model';
import { AgentePublicoPapel } from '../../../../models/acesso-cidadao.model';
import { Enums } from '../../../../shared/enums';
import { ToastrService } from 'ngx-toastr';
import { Patriarca } from '../../../../models/edocs.model';
import { EDocsService } from '../../../../services/edocs.service';
import { FlowDefinition } from '../../../../models/flow.model';
import { IBaseOption } from '../../../../models/base.model';
import { Utils } from '../../../../shared/utils';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FOD_REGISTER_PROCESS_TINYMCE_OPTIONS } from './tinymce-options';
import { FlowObjectDefinitionService } from '../../../../services/flow-object-definition.service';
import { IMPORTS } from './_imports';
import { LotacaoService } from '../../../../services/lotacao.service';
import { Comissao, GrupoTrabalho } from '../../../../models/lotacao.model';

@Component({
    selector: 'fod-register-process',
    templateUrl: './fod-register-process.component.html',
    styleUrl: './fod-register-process.component.scss',
    standalone: true,
    imports: IMPORTS,
    schemas: [NO_ERRORS_SCHEMA]
})
export class FlowObjectDetailsRegisterProcessComponent implements OnInit, OnChanges {
    // #region [Type props]
    FlowObjectType = FlowObjectType;
    StakeholderType = StakeholderType;
    StakeholderTypeDescription = StakeholderTypeDescription;
    Utils = Utils;
    // #endregion

    // #region [props]
    formFlowObjectSchemaFields: any[] = [];
    tinyMceOptionsProcess: any = FOD_REGISTER_PROCESS_TINYMCE_OPTIONS;
    patriarcas: Patriarca[] = [];
    patriarcaId = '';
    organizacaoId = '';
    unidadeId = '';
    grupoId = '';
    comissaoId = '';
    servidorNome = '';
    servidorPapelId = '';
    // #endregion

    // #region [signals]
    $configSchema = signal(null as ConfigSchema);
    $flowDefinition = signal(null as FlowDefinition);
    $isReadOnlyMode = signal(false);
    $configSchemaSectionDocumentClass = signal(new ConfigSchemaSectionDocumentClass());
    $configSchemaSectionEDocsLocation = signal(new ConfigSchemaSectionEDocsLocation());
    $patriarcaDisplay = signal('');
    $patriarcaNome = signal(null as string);
    $selectablePatriarcas = signal([] as Patriarca[]);
    $isShowingPatriarcaSection = signal(false);
    $organizacaoDisplay = signal('');
    $organizacaoNome = signal(null as string);
    $organizacoes = signal([] as Organizacao[]);
    $selectableOrganizacoes = signal([] as Organizacao[]);
    $isShowingOrganizacaoSection = signal(false);
    $unidadeDisplay = signal('');
    $unidadeNome = signal(null as string);
    $unidades = signal([] as Unidade[]);
    $selectableUnidades = signal([] as Unidade[]);
    $isShowingUnidadeSection = signal(false);
    $grupoDisplay = signal('');
    $grupoNome = signal(null as string);
    $grupos = signal([] as GrupoTrabalho[]);
    $selectableGrupos = signal([] as GrupoTrabalho[]);
    $isShowingGrupoSection = signal(false);
    $comissaoDisplay = signal('');
    $comissaoNome = signal(null as string);
    $comissoes = signal([] as Comissao[]);
    $selectableComissoes = signal([] as Comissao[]);
    $isShowingComissaoSection = signal(false);
    $servidorCpf = signal('');
    $servidorPapelDisplay = signal('');
    $servidorPapelNome = signal(null as string);
    $servidorPapeis = signal([] as AgentePublicoPapel[]);
    $selectableServidorPapeis = signal([] as AgentePublicoPapel[]);
    $isShowingServidorSection = signal(false);
    $cidadaoFormField = signal('');
    $cidadaoFormFieldOptions = signal([] as IBaseOption[]);
    $isShowingCidadaoSection = signal(false);
    $empresaCompanyName = signal(null as string);
    $empresaCompanyNameFormField = signal('');
    $empresaCompanyNameFormFieldOptions = signal([] as IBaseOption[]);
    $empresaCnpj = signal(null as string);
    $empresaCnpjFormField = signal('');
    $empresaCnpjFormFieldOptions = signal([] as IBaseOption[]);
    $empresaEmail = signal(null as string);
    $empresaEmailFormField = signal('');
    $empresaEmailFormFieldOptions = signal([] as IBaseOption[]);
    $isShowingEmpresaSection = signal(false);
    $processSummary = signal('');
    $isProcessSummaryBootstrapFinished = signal(false);
    $isCitizenFlowInstanceOwner = signal(false);
    $isEmpresaCompanyNameFreeEntry = signal(false);
    $isEmpresaCnpjFreeEntry = signal(false);
    $isEmpresaEmailFreeEntry = signal(false);
    // #endregion

    // #region [Input/Output]
    @Input() _configSchema: ConfigSchema;
    @Input() _flowDefinition: FlowDefinition;
    @Input() _isReadOnlyMode: boolean;
    @Output() _configSchemaChangeEvent = new EventEmitter<ConfigSchema>();
    // #endregion

    constructor(
        private toastr: ToastrService,
        private acessoCidadaoService: AcessoCidadaoService,
        private lotacaoService: LotacaoService,
        private organogramaService: OrganogramaService,
        private edocsService: EDocsService,
        private flowObjectDefinitionService: FlowObjectDefinitionService,
        private patriarcasFilter: PatriarcasFilter,
        private organizacoesFilter: OrganizacoesFilter,
        private unidadesFilter: UnidadesFilter,
        private gruposFilter: GruposFilter,
        private comissoesFilter: ComissoesFilter,
        private papeisFilter: PapeisFilter
    ) { }

    async ngOnInit() {
        let formFlowObject = this.$flowDefinition().flowObjectDefinitions.find(x => x.typeId == FlowObjectType.StartForm);
        if (formFlowObject != null) {
            if (Utils.isNullOrEmpty(formFlowObject.formSchema)) {
                const response = await this.flowObjectDefinitionService.getFormSchema(formFlowObject.id);

                if (!response.isSuccess) {
                    this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                    return;
                }

                formFlowObject.formSchema = response.data;
            }

            let formSchema = JSON.parse(formFlowObject.formSchema) as FormSchema;
            this.formFlowObjectSchemaFields = Utils.getFormFieldsWithUsableValue(formSchema.components);
        }

        for (let prop in this.$configSchemaSectionDocumentClass()) {
            Utils.updSignal(this.$configSchemaSectionDocumentClass, x => {
                x[prop] = this.$configSchema().taskRegisterProcess.processClass[prop] || x[prop];
                return x;
            });
        }

        this.initProcessInfo();

        const response = await this.edocsService.getPatriarcas();

        if (!response.isSuccess) {
            this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        this.patriarcas = response.data;
        this.patriarcas.sort((a, b) => {
            let first = a.sigla || a.nome || '';
            let second = b.sigla || b.nome || '';
            return first.localeCompare(second);
        });
        Utils.setSignal(this.$selectablePatriarcas, this.patriarcas);

        this.tinyMceOptionsProcess.addDynamicMenu = editor => {
            editor.ui.registry.addMenuButton('vForm', {
                text: 'Formulário',
                fetch: callback => callback(this.getTinyMceMenuFormEntries(formFlowObject, editor))
            });
        };

        // debounce para que a opção de menu "Formulário" possa carregar corretamente
        setTimeout(() => this.$isProcessSummaryBootstrapFinished.set(true), 100);
    }

    ngOnChanges() {
        this.$configSchema.set(this._configSchema);
        this.$flowDefinition.set(this._flowDefinition);
        this.$isReadOnlyMode.set(this._isReadOnlyMode);
    }

    clearProcessLocation() {
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.processLocationId = null;
            x.taskRegisterProcess.processLocationName = null;
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    processLocationIdChange(event) {
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.processLocationName = event;
            return x;
        });
    }

    onUpdateEDocsLocation(event: ConfigSchemaSectionEDocsLocation) {
        Utils.setSignal(this.$configSchemaSectionEDocsLocation, Object.assign(this.$configSchemaSectionEDocsLocation(), event));

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.processLocationId = this.$configSchemaSectionEDocsLocation().id;
            x.taskRegisterProcess.processLocationName = this.$configSchemaSectionEDocsLocation().name;
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    removeStakeholder(stakeholder: Stakeholder) {
        if (this.$isReadOnlyMode()) return;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders = x.taskRegisterProcess.stakeholders.filter(x => x.timestamp != stakeholder.timestamp);
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    removeAllStakeholders() {
        if (this.$isReadOnlyMode()) return;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders = [];
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    patriarcaDisplayChange() {
        this.$selectablePatriarcas.set(this.patriarcasFilter.transform(this.patriarcas, this.$patriarcaDisplay()));
    }

    async patriarcaIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.patriarcaId = event.option.value.id;
        }

        if (this.patriarcaId != '') {
            let patriarca = this.patriarcas.find(x => x.id == this.patriarcaId);
            this.$patriarcaNome.set(`${patriarca.sigla} - ${patriarca.nome}`);

            let response = await this.organogramaService.getOrganizacoesFilhas(this.patriarcaId);

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$organizacoes.set(response.data);
            this.$organizacoes.set(this.$organizacoes().toSorted((a, b) => {
                let first = a.sigla || a.nomeFantasia || a.razaoSocial || '';
                let second = b.sigla || b.nomeFantasia || b.razaoSocial || '';
                return first.localeCompare(second);
            }));
            Utils.setSignal(this.$selectableOrganizacoes, this.$organizacoes());
        }
    }

    displayPatriarcaId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? `${option.sigla} - ${option.nome}`
            : '';
    }

    clearPatriarca() {
        this.patriarcaId = '';
        this.$patriarcaDisplay.set('');
        this.$patriarcaNome.set(null);
        Utils.setSignal(this.$selectablePatriarcas, this.patriarcas);
        this.$organizacoes.set([]);
        this.clearOrganizacao();
        this.$unidades.set([]);
        this.clearUnidade();
    }

    selectPatriarca() {
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.patriarcaId,
                name: this.$patriarcaNome(),
                type: StakeholderType.Patriarch
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    togglePatriarcaSection() {
        this.$isShowingPatriarcaSection.set(!this.$isShowingPatriarcaSection());
    }

    organizacaoDisplayChange() {
        this.$selectableOrganizacoes.set(this.organizacoesFilter.transform(this.$organizacoes(), this.$organizacaoDisplay()));
    }

    async organizacaoIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.organizacaoId = event.option.value.guid;
        }

        if (this.organizacaoId != '') {
            let organization = this.$organizacoes().find(x => x.guid == this.organizacaoId);
            this.$organizacaoNome.set(`${organization.sigla} - ${organization.nomeFantasia == '.' ? organization.sigla : organization.nomeFantasia}`);

            let response = await this.organogramaService.getUnidadesOrganizacao(this.organizacaoId);

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$unidades.set(response.data);
            this.$unidades.set(this.$unidades().toSorted((a, b) => {
                let first = a.nomeCurto || a.nome || a.sigla || '';
                let second = b.nomeCurto || b.nome || b.sigla || '';
                return first.localeCompare(second);
            }));
            Utils.setSignal(this.$selectableUnidades, this.$unidades());

            response = await this.lotacaoService.getOrgaosGruposTrabalho(this.organizacaoId);

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$grupos.set(response.data);
            this.$grupos.set(this.$grupos().toSorted((a, b) => a.nome.localeCompare(b.nome)));
            this.$grupos.set(this.$grupos().toSorted((a, b) => {
                let first = a.nome || '';
                let second = b.nome || '';
                return first.localeCompare(second);
            }));
            Utils.setSignal(this.$selectableGrupos, this.$grupos());

            response = await this.lotacaoService.getOrgaosComissoes(this.organizacaoId);

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$comissoes.set(response.data);
            this.$comissoes.set(this.$comissoes().toSorted((a, b) => a.nome.localeCompare(b.nome)));
            this.$comissoes.set(this.$comissoes().toSorted((a, b) => {
                let first = a.nome || '';
                let second = b.nome || '';
                return first.localeCompare(second);
            }));
            Utils.setSignal(this.$selectableComissoes, this.$comissoes());
        }
    }

    displayOrganizacaoId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? `${option.sigla} - ${option.nomeFantasia == '.' ? option.sigla : option.nomeFantasia}`
            : '';
    }

    clearOrganizacao() {
        this.organizacaoId = '';
        this.$organizacaoDisplay.set('');
        this.$organizacaoNome.set(null);
        Utils.setSignal(this.$selectableOrganizacoes, this.$organizacoes());
        this.$unidades.set([]);
        this.clearUnidade();
    }

    selectOrganizacao() {
        let prefix = this.$patriarcaNome().split(' - ')[0];

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.organizacaoId,
                name: `${prefix} - ${this.$organizacaoNome()}`,
                type: StakeholderType.Organization
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    toggleOrganizacaoSection() {
        this.$isShowingOrganizacaoSection.set(!this.$isShowingOrganizacaoSection());
    }

    unidadeDisplayChange() {
        this.$selectableUnidades.set(this.unidadesFilter.transform(this.$unidades(), this.$unidadeDisplay()));
    }

    unidadeIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.unidadeId = event.option.value.guid;
        }

        if (Utils.isNullOrEmpty(this.unidadeId)) {
            this.clearUnidade();
        } else {
            let unidade = this.$unidades().find(x => x.guid == this.unidadeId);
            this.$unidadeNome.set((unidade.nomeCurto ? unidade.nomeCurto.toUpperCase() + ' - ' : '') + unidade.nome.toUpperCase());
        }
    }

    displayUnidadeId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? `${option.nomeCurto ? option.nomeCurto.toUpperCase() + ' - ' : ''}${option.nome.toUpperCase()}`
            : '';
    }

    clearUnidade() {
        this.unidadeId = '';
        this.$unidadeDisplay.set('');
        this.$unidadeNome.set(null);
        Utils.setSignal(this.$selectableUnidades, this.$unidades());
    }

    selectUnidade() {
        let prefix = this.$patriarcaNome().split(' - ')[0];
        prefix += ` - ${this.$organizacaoNome().split(' - ')[0]}`;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.unidadeId,
                name: `${prefix} - ${this.$unidadeNome()}`,
                type: StakeholderType.Unit
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    toggleUnidadeSection() {
        this.$isShowingUnidadeSection.set(!this.$isShowingUnidadeSection());
    }

    grupoDisplayChange() {
        this.$selectableGrupos.set(this.gruposFilter.transform(this.$grupos(), this.$grupoDisplay()));
    }

    grupoIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.grupoId = event.option.value.id;
        }

        if (Utils.isNullOrEmpty(this.grupoId)) {
            this.clearGrupo();
        } else {
            this.$grupoNome.set(this.$grupos().find(x => x.id == this.grupoId).nome.toUpperCase());
        }
    }

    displayGrupoId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? option.nome.toUpperCase()
            : '';
    }

    clearGrupo() {
        this.grupoId = '';
        this.$grupoDisplay.set('');
        this.$grupoNome.set(null);
        Utils.setSignal(this.$selectableGrupos, this.$grupos());
    }

    selectGrupo() {
        let prefix = this.$patriarcaNome().split(' - ')[0];
        prefix += ` - ${this.$organizacaoNome().split(' - ')[0]}`;
        prefix += ` - ${this.$unidadeNome().split(' - ')[0]}`;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.grupoId,
                name: `${prefix} - ${this.$grupoNome()}`,
                type: StakeholderType.Group
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    toggleGrupoSection() {
        this.$isShowingGrupoSection.set(!this.$isShowingGrupoSection());
    }

    comissaoDisplayChange() {
        this.$selectableComissoes.set(this.comissoesFilter.transform(this.$comissoes(), this.$comissaoDisplay()));
    }

    comissaoIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.comissaoId = event.option.value.id;
        }

        if (Utils.isNullOrEmpty(this.comissaoId)) {
            this.clearComissao();
        } else {
            this.$comissaoNome.set(this.$comissoes().find(x => x.id == this.comissaoId).nome.toUpperCase());
        }
    }

    displayComissaoId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? option.nome.toUpperCase()
            : '';
    }

    clearComissao() {
        this.comissaoId = '';
        this.$comissaoDisplay.set('');
        this.$comissaoNome.set(null);
        Utils.setSignal(this.$selectableComissoes, this.$comissoes());
    }

    selectComissao() {
        let prefix = this.$patriarcaNome().split(' - ')[0];
        prefix += ` - ${this.$organizacaoNome().split(' - ')[0]}`;
        prefix += ` - ${this.$unidadeNome().split(' - ')[0]}`;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.comissaoId,
                name: `${prefix} - ${this.$comissaoNome()}`,
                type: StakeholderType.Comission
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    toggleComissaoSection() {
        this.$isShowingComissaoSection.set(!this.$isShowingComissaoSection());
    }

    servidorPapelDisplayChange() {
        this.$selectableServidorPapeis.set(this.papeisFilter.transform(this.$servidorPapeis(), this.$servidorPapelDisplay()));
    }

    servidorPapelIdChange(event?: MatAutocompleteSelectedEvent) {
        if (event != null) {
            this.servidorPapelId = event.option.value.guid;
        }

        if (Utils.isNullOrEmpty(this.servidorPapelId)) {
            this.clearServidorPapel();
        } else {
            let servidor = this.$servidorPapeis().find(x => x.guid == this.servidorPapelId);
            this.$servidorPapelNome.set(servidor.nome.toUpperCase());
        }
    }

    displayServidorPapelId(option): string {
        return Utils.isNotNullOrEmpty(option)
            ? option.nome.toUpperCase()
            : '';
    }

    clearServidorPapel() {
        this.servidorPapelId = '';
        this.$servidorPapelDisplay.set('');
        this.$servidorPapelNome.set(null);
        Utils.setSignal(this.$selectableServidorPapeis, this.$servidorPapeis());
    }

    selectServidorPapel() {
        let papel = this.$servidorPapeis().find(x => x.guid == this.servidorPapelId);
        let suffix = papel.lotacao.nomeCurto;
        suffix += ` - ${papel.lotacao.organizacao.sigla}`;
        suffix += ` - ${papel.lotacao.organizacao.organizacaoPai.sigla}`;

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                id: this.servidorPapelId,
                name: `${this.servidorNome} - ${this.$servidorPapelNome()} - ${suffix}`,
                type: StakeholderType.PublicAgent
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    async searchServidorCpf() {
        if (Utils.isNotNullOrEmpty(this.$servidorCpf())) {
            let response = await this.acessoCidadaoService.getAgentePublicoSub(this.$servidorCpf());

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            response = await this.acessoCidadaoService.getAgentePublico(response.data.sub);

            if (!response.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.servidorNome = response.data.nome;

            let responsePapeis = await this.acessoCidadaoService.getAgentePublicoPapeis(response.data.sub);

            if (!responsePapeis.isSuccess) {
                this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$servidorPapeis.set(responsePapeis.data);
            this.$servidorPapeis.set(this.$servidorPapeis().toSorted((a, b) => {
                let first = a.nome || '';
                let second = b.nome || '';
                return first.localeCompare(second);
            }));
            Utils.setSignal(this.$selectableServidorPapeis, this.$servidorPapeis());
        }
    }

    clearServidorCpf() {
        this.$servidorCpf.set('');
    }

    toggleServidorSection() {
        this.$isShowingServidorSection.set(!this.$isShowingServidorSection());
    }

    selectCidadaoFlowInstanceOwner() {
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                name: 'Instanciador do Fluxo',
                isCitizenFlowInstanceOwner: true,
                type: StakeholderType.Citizen
            }));
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    selectCidadaoFormField() {
        if (Utils.isNotNullOrEmpty(this.$cidadaoFormField())) {
            Utils.updSignal(this.$configSchema, x => {
                x.taskRegisterProcess.stakeholders.push(new Stakeholder({
                    name: `CPF obtido do campo "${this.$cidadaoFormField()}"`,
                    citizenCpfFormField: this.$cidadaoFormField(),
                    type: StakeholderType.Citizen
                }));
                return x;
            });

            this._configSchemaChangeEvent.emit(this.$configSchema());
        }
    }

    clearCidadaoFormField() {
        this.$cidadaoFormField.set('');
    }

    toggleCidadaoSection() {
        this.$isShowingCidadaoSection.set(!this.$isShowingCidadaoSection());
    }

    addCompanyStakeholder() {
        let stakeholder = new Stakeholder({
            type: StakeholderType.Company
        });

        if (Utils.isNotNullOrEmpty(this.$empresaCompanyName())) {
            stakeholder.companyName = this.$empresaCompanyName();
        } else {
            stakeholder.companyName = `Razão Social obtida do campo "${this.$empresaCompanyNameFormField()}"`;
            stakeholder.companyNameFormField = this.$empresaCompanyNameFormField();
        }

        if (Utils.isNotNullOrEmpty(this.$empresaCnpj())) {
            stakeholder.cnpj = this.$empresaCnpj();
        } else {
            stakeholder.cnpj = `CNPJ obtido do campo "${this.$empresaCnpjFormField()}"`;
            stakeholder.cnpjFormField = this.$empresaCnpjFormField();
        }

        if (Utils.isNotNullOrEmpty(this.$empresaEmail())) {
            stakeholder.email = this.$empresaEmail();
        } else {
            stakeholder.email = `E-mail obtido do campo "${this.$empresaEmailFormField()}"`;
            stakeholder.emailFormField = this.$empresaEmailFormField();
        }

        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.stakeholders.push(stakeholder);
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    shouldDisableAddCompanyStakeholder(): boolean {
        return (this.$isEmpresaCompanyNameFreeEntry() && Utils.isNullOrEmpty(this.$empresaCompanyName()))
            || (!this.$isEmpresaCompanyNameFreeEntry() && Utils.isNullOrEmpty(this.$empresaCompanyNameFormField()))
            || (this.$isEmpresaCnpjFreeEntry() && Utils.isNullOrEmpty(this.$empresaCnpj()))
            || (!this.$isEmpresaCnpjFreeEntry() && Utils.isNullOrEmpty(this.$empresaCnpjFormField()))
            || (this.$isEmpresaEmailFreeEntry() && Utils.isNullOrEmpty(this.$empresaEmail()))
            || (!this.$isEmpresaEmailFreeEntry() && Utils.isNullOrEmpty(this.$empresaEmailFormField()));
    }

    clearEmpresaCompanyName(event) {
        this.$empresaCompanyNameFormField.set(event);
        this.$empresaCompanyName.set(null);
    }

    clearEmpresaCompanyNameFormField(event) {
        this.$empresaCompanyName.set(event);
        this.$empresaCompanyNameFormField.set('');
    }

    clearEmpresaCnpj(event) {
        this.$empresaCnpjFormField.set(event);
        this.$empresaCnpj.set(null);
    }

    clearEmpresaCnpjFormField(event) {
        this.$empresaCnpj.set(event);
        this.$empresaCnpjFormField.set('');
    }

    clearEmpresaEmail(event) {
        this.$empresaEmailFormField.set(event);
        this.$empresaEmail.set(null);
    }

    clearEmpresaEmailFormField(event) {
        this.$empresaEmail.set(event);
        this.$empresaEmailFormField.set('');
    }

    toggleEmpresaSection() {
        this.$isShowingEmpresaSection.set(!this.$isShowingEmpresaSection());
    }

    updateSourceCode(forcedConfigSchema: ConfigSchema) {
        Utils.setSignal(this.$configSchema, forcedConfigSchema);

        // limpando deliberadamente as configurações de Classe enquanto o E-Docs não deixar os GUIDs
        // de classe documental únicos dentre todos os ambientes, a exemplo dos do Organograma
        //Utils.setSignal(this.$configSchemaSectionDocumentClass, Object.assign(this.$configSchemaSectionDocumentClass(), this.$configSchema().taskRegisterProcess.processClass));
        Utils.setSignal(this.$configSchemaSectionDocumentClass, new ConfigSchemaSectionDocumentClass());
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.processClass = new ConfigSchemaSectionDocumentClass();
            return x;
        });

        this.initProcessInfo();

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    onUpdateProcessClass(event: ConfigSchemaSectionDocumentClass) {
        Utils.setSignal(this.$configSchemaSectionDocumentClass, Object.assign(this.$configSchemaSectionDocumentClass(), event));

        Utils.updSignal(this.$configSchema, x => {
            Object.assign(x.taskRegisterProcess.processClass, this.$configSchemaSectionDocumentClass());
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());
    }

    resolveProcessInfo(): boolean {
        if (this.$processSummary()?.length < 5) {
            this.toastr.error(Enums.Messages.MandatoryProcessSummary, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return false;
        }

        let div = document.createElement('div');
        div.innerHTML = this.$processSummary()?.replaceAll('<br />', '\n');
        Utils.updSignal(this.$configSchema, x => {
            x.taskRegisterProcess.processSummary = div.textContent || div.innerText || '';
            return x;
        });

        this._configSchemaChangeEvent.emit(this.$configSchema());

        return true;
    }

    // #region [===== private methods =====]
    // #endregion

    private initProcessInfo() {
        this.$processSummary.set(this.$configSchema().taskRegisterProcess.processSummary?.replaceAll('\n', '<br />'));

        this.$cidadaoFormFieldOptions.set(this.formFlowObjectSchemaFields.map(x => ({ value: x.key, description: x.label })));
        this.$empresaCompanyNameFormFieldOptions.set(this.formFlowObjectSchemaFields.map(x => ({ value: x.key, description: x.label })));
        this.$empresaCnpjFormFieldOptions.set(this.formFlowObjectSchemaFields.map(x => ({ value: x.key, description: x.label })));
        this.$empresaEmailFormFieldOptions.set(this.formFlowObjectSchemaFields.map(x => ({ value: x.key, description: x.label })));
    }

    private getTinyMceMenuFormEntries(flowObject: FlowObjectDefinition, editor): any[] {
        if (Utils.isNullOrEmpty(flowObject.formSchema)) return;

        let entries = [];
        let formSchema = JSON.parse(flowObject.formSchema) as FormSchema;

        Utils.getFormFieldsWithUsableValue(formSchema.components).forEach(item => {
            entries.push({
                type: 'menuitem',
                text: item.label,
                onAction: () => editor.insertContent(`{|${item.key}|}`)
            });
        });

        return entries;
    }
}
